export const FLAGS_FORM_FIELDS_NAMES = {
    SEARCH_PATIENT_FLAG: 'SearchPatientFlag'
}